/* unplugin-vue-components disabled */import script from "./helpCustom.vue?vue&type=script&setup=true&lang=ts"
export * from "./helpCustom.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__